export const siteInfo = {
  name: '被窝影院',
  slogan: '躺在被窝里，追遍全网热剧',
  tag: '🔥 全网热播',
  description: '被窝影院是国内领先的免费电视剧大全平台，致力于为追剧爱好者提供全集在线看最新电视剧免费服务。我们每日更新超过50部热播剧完整版，覆盖国产剧免费观看、韩剧、美剧、日剧等全品类资源。高清流畅在线不缓冲，无论你是追最新古装大剧还是重温经典老片，被窝影院都是你的追剧首选平台。',
  description2: '平台采用先进视频分发技术，确保每位用户都能享受高清流畅的观影体验。从热播古装传奇到烧脑悬疑刑侦，从甜蜜都市情感到震撼科幻巨制，海量片库满足不同口味。',
  stats: [
    { label: '部剧集', value: '10000+' },
    { label: '每日更新', value: '50+' },
    { label: '高清画质', value: '1080P' },
  ],
};

export const mediaItems = [
  {
    id: 1,
    title: '长安十二时辰',
    subtitle: '古装悬疑巨制',
    tag: '热门',
    views: '3.2亿',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20interior%20with%20warm%20lantern%20glow%2C%20traditional%20Tang%20dynasty%20architecture%2C%20dramatic%20cinematic%20lighting%20with%20deep%20shadows%2C%20rich%20amber%20and%20crimson%20tones%2C%20atmospheric%20period%20drama%20aesthetic%2C%20high%20production%20value%20film%20still&width=600&height=340&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '狂飙',
    subtitle: '年度现象级刑侦剧',
    tag: '爆款',
    views: '5.6亿',
    image: 'https://readdy.ai/api/search-image?query=Moody%20urban%20night%20scene%20in%20modern%20Chinese%20city%20with%20rain%20slicked%20streets%20reflecting%20neon%20lights%2C%20film%20noir%20atmosphere%2C%20dramatic%20shadows%20through%20windows%2C%20suspenseful%20crime%20drama%20cinematic%20mood%2C%20deep%20contrast%20lighting&width=600&height=340&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '庆余年第二季',
    subtitle: '古装传奇巅峰回归',
    tag: '新番',
    views: '4.1亿',
    image: 'https://readdy.ai/api/search-image?query=Epic%20mountain%20landscape%20with%20ancient%20Chinese%20palace%20complex%20perched%20on%20cliffs%2C%20misty%20atmosphere%20during%20golden%20sunset%20hour%2C%20traditional%20rooftops%20with%20curved%20eaves%2C%20sweeping%20cinematic%20vista%2C%20warm%20dramatic%20lighting%2C%20fantasy%20wuxia%20aesthetic&width=600&height=340&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '三体',
    subtitle: '科幻文学巅峰改编',
    tag: '推荐',
    views: '2.8亿',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20observatory%20with%20massive%20telescope%20pointing%20at%20deep%20space%2C%20cosmic%20nebula%20in%20purple%20and%20gold%20hues%2C%20sleek%20architectural%20interior%2C%20atmospheric%20cinematic%20lighting%2C%20mysterious%20and%20awe-inspiring%20mood%2C%20high%20concept%20science%20fiction&width=600&height=340&seq=media-04&orientation=landscape',
  },
];

export const topicItems = [
  { id: 1, name: '古装剧', hot: true, count: '2.3万' },
  { id: 2, name: '悬疑剧', hot: true, count: '1.8万' },
  { id: 3, name: '都市情感', hot: false, count: '1.5万' },
  { id: 4, name: '科幻巨制', hot: true, count: '9860' },
  { id: 5, name: '刑侦谍战', hot: false, count: '1.2万' },
  { id: 6, name: '甜宠剧场', hot: false, count: '2.1万' },
  { id: 7, name: '奇幻仙侠', hot: true, count: '1.6万' },
  { id: 8, name: '历史正剧', hot: false, count: '8790' },
  { id: 9, name: '喜剧搞笑', hot: false, count: '1.1万' },
  { id: 10, name: '家庭伦理', hot: false, count: '7650' },
  { id: 11, name: '短剧合集', hot: true, count: '3.5万' },
];

export const cardItems = [
  {
    id: 1,
    title: '繁花',
    subtitle: '王家卫首部电视剧',
    desc: '上海滩九十年代风云变幻，阿宝在资本市场与情感的漩涡中沉浮，演绎一段荡气回肠的都市传奇。',
    tag: '热播',
    rating: '9.3',
    image: 'https://readdy.ai/api/search-image?query=Shanghai%20cityscape%20in%20the%201990s%20with%20vintage%20street%20lights%2C%20elegant%20old%20buildings%20along%20the%20Bund%2C%20warm%20nostalgic%20golden%20hour%20lighting%2C%20retro%20Chinese%20urban%20atmosphere%2C%20cinematic%20film%20still%20quality%2C%20rich%20warm%20tones&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '漫长的季节',
    subtitle: '辛爽执导悬疑力作',
    desc: '东北小城跨越二十年的碎尸悬案，三个普通人的命运因一桩旧案纠缠交织，无法挣脱。',
    tag: '高分',
    rating: '9.4',
    image: 'https://readdy.ai/api/search-image?query=Northeast%20China%20small%20industrial%20town%20in%20autumn%2C%20old%20factory%20buildings%20with%20rusty%20pipes%2C%20golden%20fall%20foliage%20along%20quiet%20streets%2C%20nostalgic%20and%20slightly%20melancholic%20atmosphere%2C%20cinematic%20wide%20shot%2C%20muted%20warm%20tones&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '莲花楼',
    subtitle: '古装武侠探案传奇',
    desc: '神秘莲花楼主人李莲花与热血少侠方多病、笛飞声联手破案，在江湖恩怨中揭开惊天秘密。',
    tag: '新剧',
    rating: '8.8',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20lotus%20pond%20with%20ancient%20wooden%20pavilion%2C%20blooming%20pink%20lotus%20flowers%2C%20misty%20morning%20light%20filtering%20through%20willow%20trees%2C%20serene%20martial%20arts%20aesthetic%2C%20soft%20dreamy%20atmosphere%2C%20ink%20painting%20style%20composition&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '与凤行',
    subtitle: '赵丽颖林更新再搭档',
    desc: '魔界女王爷沈璃逃婚坠落人间，与上古神君行止相遇，从相杀到相爱，谱写三界旷世情缘。',
    tag: '热播',
    rating: '8.5',
    image: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20landscape%20with%20floating%20islands%20and%20waterfalls%2C%20ancient%20immortal%20palace%20in%20clouds%2C%20phoenix%20feather%20motif%20in%20warm%20golden%20and%20crimson%20tones%2C%20dreamy%20xianxia%20aesthetic%2C%20soft%20celestial%20lighting&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '玫瑰的故事',
    subtitle: '刘亦菲演绎女性成长',
    desc: '黄亦玫从青涩少女到成熟女性的二十年人生历程，在爱情与事业的辗转中寻找真正的自我价值。',
    tag: '热播',
    rating: '8.2',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20rose%20garden%20in%20full%20bloom%20with%20soft%20morning%20sunlight%2C%20elegant%20vintage%20Chinese%20courtyard%2C%20delicate%20pink%20and%20cream%20rose%20petals%2C%20feminine%20and%20warm%20atmosphere%2C%20soft%20focus%20cinematic%20quality%2C%20contemporary%20romance%20aesthetic&width=600&height=400&seq=card-05&orientation=landscape',
  },
];

export const indexItems = [
  { id: 1, name: '古装大剧', icon: 'ri-building-2-line', desc: '宫廷权谋·仙侠奇幻·武侠江湖' },
  { id: 2, name: '都市情感', icon: 'ri-heart-line', desc: '甜宠爱情·职场奋斗·家庭温情' },
  { id: 3, name: '悬疑探案', icon: 'ri-search-eye-line', desc: '烧脑推理·犯罪刑侦·谍战暗战' },
  { id: 4, name: '科幻未来', icon: 'ri-rocket-line', desc: '硬核科幻·末日求生·AI觉醒' },
  { id: 5, name: '谍战风云', icon: 'ri-shield-flash-line', desc: '民国谍影·现代反恐·卧底潜伏' },
  { id: 6, name: '甜宠剧场', icon: 'ri-emotion-happy-line', desc: '先婚后爱·霸总宠妻·校园初恋' },
  { id: 7, name: '历史正剧', icon: 'ri-book-open-line', desc: '王朝兴衰·英雄史诗·历史传奇' },
  { id: 8, name: '喜剧专区', icon: 'ri-emotion-laugh-line', desc: '情景喜剧·黑色幽默·爆笑短剧' },
];

export const aboutContent = {
  title: '关于被窝影院',
  paragraphs: [
    '被窝影院创立于2020年，是国内领先的免费电视剧在线观看平台。我们秉持"追剧本该快乐"的理念，致力于为全国追剧爱好者提供高清流畅、资源丰富的免费电视剧大全服务。平台日均服务超过300万用户，已成为国产剧免费观看的首选入口。',
    '我们的内容团队全天候追踪各大平台最新电视剧免费资源，确保全集在线看体验始终领先。从热播剧完整版到经典老片，从国产佳剧到海外精选，被窝影院以专业技术和用心服务，让每一位用户躺在被窝里就能畅享追剧乐趣。',
  ],
  highlights: [
    { icon: 'ri-movie-line', label: '10000+', desc: '海量剧集' },
    { icon: 'ri-user-smile-line', label: '300万+', desc: '日活用户' },
    { icon: 'ri-timer-flash-line', label: '24H', desc: '全天更新' },
    { icon: 'ri-shield-check-line', label: '安全', desc: '无广告纯净' },
  ],
};

export const updateItems = [
  { id: 1, date: '2026-07-31', text: '《唐朝诡事录之西行》全集更新完毕，会员可一次看完全集', tag: '新剧上线' },
  { id: 2, date: '2026-07-30', text: '《墨雨云间》播放量突破50亿，吴谨言王星越演技获赞', tag: '热播' },
  { id: 3, date: '2026-07-29', text: '《狐妖小红娘月红篇》杨幂龚俊版本正式上线，漫改剧再添力作', tag: '新番' },
  { id: 4, date: '2026-07-28', text: '平台服务器全面升级，4K超清画质流畅播放不卡顿', tag: '公告' },
  { id: 5, date: '2026-07-27', text: '《少年白马醉春风》首播口碑爆棚，武侠剧市场再掀热潮', tag: '热播' },
  { id: 6, date: '2026-07-26', text: '《长相思第二季》定档8月8日，杨紫张晚意再度携手', tag: '预告' },
  { id: 7, date: '2026-07-25', text: '暑期档追剧指南发布，涵盖古装、悬疑、甜宠等六大类型', tag: '专题' },
  { id: 8, date: '2026-07-24', text: '《四方馆》檀健次主演，轻喜剧风格古装探案剧火热更新中', tag: '更新' },
  { id: 9, date: '2026-07-23', text: '被窝影院App端上线弹幕功能，追剧互动体验全面升级', tag: '功能' },
];

export const contactContent = {
  intro: '有想看的剧？遇到播放问题？欢迎随时联系我们。被窝影院客服团队7×24小时在线，为你解决追剧路上的所有问题。',
  items: [
    { icon: 'ri-mail-line', label: '联系邮箱', value: 'feedback@beiwomovie.com' },
    { icon: 'ri-wechat-line', label: '微信公众号', value: '被窝影院官方' },
    { icon: 'ri-tiktok-line', label: '抖音号', value: '@beiwomovie' },
    { icon: 'ri-weibo-line', label: '微博', value: '@被窝影院官微' },
  ],
};

export const appContent = {
  title: '随时随地，被窝追剧',
  subtitle: '下载被窝影院App，离线缓存、弹幕互动、夜间模式等你体验',
  features: ['离线下载，无网也能看', '智能推荐，越看越懂你', '弹幕互动，边看边聊', '夜间模式，护眼追剧'],
  qrImage: 'https://readdy.ai/api/search-image?query=Minimalist%20QR%20code%20design%20with%20warm%20cinema%20theme%2C%20film%20reel%20motif%20in%20center%2C%20clean%20modern%20mobile%20app%20interface%20mockup%2C%20soft%20warm%20gradient%20background%2C%20subtle%20glow%20effect&width=400&height=400&seq=app-qr-01&orientation=squarish',
  mockupImage: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20Chinese%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%2C%20warm%20cinema%20theme%20colors%2C%20clean%20modern%20UI%20design%2C%20phone%20floating%20on%20soft%20background%2C%20editorial%20product%20photography%20style&width=500&height=600&seq=app-mockup-01&orientation=portrait',
};

export const carouselItems = [
  {
    id: 1,
    title: '暑期档·古装盛宴',
    desc: '今夏最强国剧阵容，从权谋到仙侠，从江湖到宫廷，精选十部必看古装大剧陪你度过炎炎夏日。',
    tag: '专题',
    image: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20imperial%20city%20at%20sunset%20with%20grand%20palace%20gates%2C%20warm%20golden%20light%20streaming%20through%20clouds%2C%20traditional%20architecture%20silhouettes%2C%20cinematic%20widescreen%20composition%2C%20rich%20amber%20and%20crimson%20color%20palette&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '悬疑烧脑·高能反转',
    desc: '精选年度口碑悬疑剧集，每一部都让你欲罢不能。从真实案件改编到原创脑洞，层层反转直到最后一秒。',
    tag: '专题',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20dimly%20lit%20detective%20office%20with%20evidence%20board%20covered%20in%20photos%20and%20red%20strings%2C%20venetian%20blind%20shadows%2C%20film%20noir%20atmosphere%2C%20suspenseful%20cinematic%20mood%2C%20deep%20contrast%20lighting%2C%20warm%20amber%20desk%20lamp&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '甜宠当道·心动一夏',
    desc: '从校园初恋到都市情缘，最甜的剧都在这儿。高颜值CP组合，治愈每一个被窝里的追剧夜晚。',
    tag: '专题',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20sunset%20scene%20at%20a%20university%20campus%20with%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20golden%20light%2C%20young%20couple%20silhouettes%20on%20a%20bench%2C%20dreamy%20atmospheric%20quality%2C%20warm%20tender%20mood&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '科幻纪元·想象无界',
    desc: '国产科幻剧集全面崛起，从《三体》到更多硬核作品，带你探索宇宙奥秘与未来世界。',
    tag: '专题',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20station%20interior%20with%20panoramic%20window%20showing%20Earth%20from%20orbit%2C%20sleek%20metallic%20architecture%2C%20holographic%20displays%2C%20soft%20ambient%20blue%20and%20gold%20lighting%2C%20high%20concept%20science%20fiction%20aesthetic&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '经典重温·百看不厌',
    desc: '那些年我们追过的神剧，无论重温多少遍都依然精彩。从《甄嬛传》到《琅琊榜》，经典永不过时。',
    tag: '专题',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20Chinese%20film%20projector%20casting%20warm%20light%20in%20a%20dark%20room%2C%20old%20movie%20posters%20on%20brick%20wall%2C%20nostalgic%20cinema%20atmosphere%2C%20dust%20particles%20floating%20in%20light%20beam%2C%20warm%20sepia%20tones%2C%20classic%20movie%20theater%20aesthetic&width=800&height=450&seq=carousel-05&orientation=landscape',
  },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-database-2-line',
    title: '海量片库',
    desc: '收录超过10000部电视剧资源，涵盖国产剧、韩剧、美剧、日剧、泰剧等全品类，热播剧完整版实时更新，你想看的这里都有。',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '高清流畅',
    desc: '支持1080P超清画质播放，采用智能CDN加速技术，确保全国各地用户都能享受流畅不缓冲的追剧体验。',
  },
  {
    id: 3,
    icon: 'ri-timer-line',
    title: '每日更新',
    desc: '专业内容团队24小时不间断更新，新剧上线第一时间同步，热门剧集与卫视同步更新，不再错过任何精彩。',
  },
  {
    id: 4,
    icon: 'ri-vip-crown-line',
    title: '永久免费',
    desc: '坚持免费电视剧大全的初心，所有剧集无需付费即可观看。纯净观影体验，绝不强制用户充值会员。',
  },
];

export const faqItems = [
  {
    id: 1,
    q: '被窝影院真的完全免费吗？',
    a: '是的，被窝影院始终坚持免费电视剧大全的定位，所有国产剧免费观看、热播剧完整版均可免费在线播放，无需充值会员。我们通过广告和品牌合作维持运营，不会向用户强制收费。',
  },
  {
    id: 2,
    q: '为什么有些剧集播放会卡顿？',
    a: '播放卡顿通常与您的网络环境有关。被窝影院采用智能CDN分发技术，建议您检查网络连接，或切换播放线路。我们的高清流畅在线服务在4G及以上网络环境下均可顺畅播放。',
  },
  {
    id: 3,
    q: '新剧上线后多久能更新？',
    a: '被窝影院拥有专业的内容更新团队，热播剧集通常在卫视播出后2小时内即可完成全集在线看更新。部分热门剧集我们还会提前准备多线路资源，确保用户第一时间追到最新电视剧免费内容。',
  },
  {
    id: 4,
    q: '可以在手机上观看吗？',
    a: '当然可以！被窝影院全面支持手机、平板和电脑端观看。您可以直接在浏览器中打开，也可以下载被窝影院App获得更好的移动追剧体验，支持离线缓存和弹幕互动功能。',
  },
];

export const commentItems = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20woman%20with%20warm%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20friendly%20casual%20portrait%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '追剧小达人',
    date: '2026-07-30',
    text: '被窝影院真的是我发现的宝藏！剧集更新速度超快，《庆余年第二季》卫视刚播完这里就有高清全集了，画质还特别好。晚上躺在被窝里追剧太幸福了～',
    likes: 1286,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20man%20in%20his%20thirties%2C%20friendly%20expression%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20casual%20portrait%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '深夜放映室',
    date: '2026-07-29',
    text: '作为悬疑剧爱好者，被窝影院的分类索引太方便了。《漫长的季节》一口气刷完，流畅不卡顿，比很多收费平台体验都好。强烈推荐给所有追剧党！',
    likes: 956,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20woman%20with%20glasses%2C%20intellectual%20look%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20friendly%20portrait%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '剧荒拯救者',
    date: '2026-07-28',
    text: '剧荒的时候就来被窝影院翻榜单，热门话题和推荐都特别准。上次被安利的《莲花楼》真的香！国产剧免费观看还能有这么好的体验，必须五星好评。',
    likes: 2034,
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20man%20in%20casual%20style%2C%20warm%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20friendly%20portrait%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '老剧爱好者',
    date: '2026-07-27',
    text: '找了很久的老剧《甄嬛传》高清版终于在被窝影院找到了，全集在线看太方便了。片库是真的大，从经典老片到最新电视剧免费资源都有，已经安利给全家人了。',
    likes: 1587,
  },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '狂飙', type: '刑侦剧', hot: '本周播放量 5.6亿', change: 'up' },
  { id: 2, rank: 2, title: '庆余年第二季', type: '古装传奇', hot: '本周播放量 4.1亿', change: 'up' },
  { id: 3, rank: 3, title: '长安十二时辰', type: '古装悬疑', hot: '本周播放量 3.2亿', change: 'same' },
  { id: 4, rank: 4, title: '漫长的季节', type: '悬疑剧', hot: '本周播放量 2.9亿', change: 'up' },
  { id: 5, rank: 5, title: '繁花', type: '都市剧', hot: '本周播放量 2.6亿', change: 'down' },
];

export const footerLinks = {
  nav: [
    { label: '焦点专题', href: '#carousel' },
    { label: '精彩推荐', href: '#media' },
    { label: '热播剧集', href: '#cards' },
    { label: '最新动态', href: '#updates' },
    { label: '常见问题', href: '#faq' },
  ],
  types: [
    { label: '古装剧', href: '#' },
    { label: '都市剧', href: '#' },
    { label: '悬疑剧', href: '#' },
    { label: '科幻剧', href: '#' },
    { label: '谍战剧', href: '#' },
  ],
};